import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.nvaTeal,
  fillHoverColor: colors.nvaTeal,
  iconColor: colors.white,
  iconHoverColor: colors.white,
  iconBorderColor: 'transparent',
  opacity: 0.8
};
export default socialIcon;